/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.createAppPassword'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  name: /*#__PURE__*/ l.string(),
  privileged: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.payload(
  'application/json',
  /*#__PURE__*/ l.ref<AppPassword>((() => appPassword) as any),
)

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Create an App Password. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'AccountTakedown',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type AppPassword = {
  $type?: 'com.atproto.server.createAppPassword#appPassword'
  name: string
  password: string
  createdAt: l.DatetimeString
  privileged?: boolean
}

export type { AppPassword }

const appPassword = /*#__PURE__*/ l.typedObject<AppPassword>(
  $nsid,
  'appPassword',
  /*#__PURE__*/ l.object({
    name: /*#__PURE__*/ l.string(),
    password: /*#__PURE__*/ l.string(),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    privileged: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  }),
)

export { appPassword }
